import { setCookie, deleteCookie } from "./utils";
window.addEventListener("message", (e) => {
  console.log("inside the hints message handler");
  (async () => {
    if (!ALLOWED_ORIGINS.includes(e.origin)) {
      console.log("origin not allowed", e.origin);
      return;
    }
    console.log("origin allowed");
    let storageAccess = false;
    let permissionsResponse;
    if (!document.hasStorageAccess) {
      // Storage Access API is not supported
      // We assume it is an older browser that does not block third party cookies
      storageAccess = true;
    } else {
      console.log("querying storage access permission");
      permissionsResponse = await navigator.permissions.query({
        name: "storage-access",
      });
      console.log("permissions response", permissionsResponse.state);
      if (permissionsResponse.state === "granted") {
        storageAccess = true;
      } else {
        storageAccess = await document.requestStorageAccess({
          localStorage: true,
        });
      }
    }
    console.log("storage access", storageAccess);
    if (storageAccess) {
      try {
        switch (e.data.type) {
          case "read":
            console.log("reading hints");
            const authHints = readAuthHints();
            e.source.postMessage(
              { payload: authHints, type: "success" },
              e.origin
            );
            console.log("auth hints read", authHints);
            break;
          case "write":
            writeAuthHints({
              login_hint: e.data.login_hint,
              idp_id: e.data.idp_id,
              timestamp: e.data.timestamp,
              sub: e.data.sub,
            });
            e.source.postMessage({ type: "success" }, e.origin);
            break;
          case "delete":
            deleteAuthHints();
            e.source.postMessage({ type: "success" }, e.origin);
            break;
        }
      } catch (error) {
        console.log("error in reading/writing/deleting hints", error);
        e.source.postMessage({ type: "error", payload: error }, e.origin);
      }
    } else {
      e.source.postMessage(
        {
          type: "error",
          payload: { name: "3PC", message: "storage access not granted" },
        },
        e.origin
      );
    }
  })();
});

const readAuthHints = () => {
  return JSON.parse(localStorage.getItem(LOGIN_HINTS_ITEM_NAME));
};
const deleteAuthHints = () => {
  localStorage.removeItem(LOGIN_HINTS_ITEM_NAME);
  deleteCookie(LOGIN_HINTS_ITEM_NAME);
};
const writeAuthHints = (authHints) => {
  localStorage.setItem(LOGIN_HINTS_ITEM_NAME, JSON.stringify(authHints));
  setCookie(JSON.stringify(authHints), LOGIN_HINTS_ITEM_NAME);
};
